import angular from 'angular';
import { MeurhVisualizarArquivoModalController } from './modal/visualizararquivo/visualizararquivo.modal.controller';
import { MeurhVisualizarArquivoModalService } from './modal/visualizararquivo/visualizararquivo.modal.service';

import { MeurhArquivosTrabalhadorIndexController } from './trabalhador/index/arquivos.trabalhador.index.controller';
import { MeurhArquivosTrabalhadorService } from './trabalhador/arquivos.trabalhador.service';
import { MeurhArquivosTrabalhadorComponent } from './trabalhador/arquivos.trabalhador.component';
import { MeurhArquivosTrabalhadorUploadModalController } from './trabalhador/modals/upload/arquivos.trabalhador.upload.modal.controller';
import { MeurhArquivosTrabalhadorUploadModalService } from './trabalhador/modals/upload/arquivos.trabalhador.upload.modal.service';

import { MeurhArquivosEmpresaIndexController } from './empresa/index/arquivos.empresa.index.controller';
import { MeurhArquivosEmpresaService } from './empresa/arquivos.empresa.service';
import { MeurhArquivosEmpresaRouting } from './empresa/arquivos.empresa.routing';

export const MeurhArquivosModule = angular.module('MeurhArquivosModule', ['ui.router.state'])
    .controller('MeurhVisualizarArquivoModalController', MeurhVisualizarArquivoModalController)
    .controller('MeurhArquivosTrabalhadorIndexController', MeurhArquivosTrabalhadorIndexController)
    .controller('MeurhArquivosTrabalhadorUploadModalController', MeurhArquivosTrabalhadorUploadModalController)
    .controller('MeurhArquivosEmpresaIndexController', MeurhArquivosEmpresaIndexController)
    .component('meurhArquivosTrabalhadorComponent', MeurhArquivosTrabalhadorComponent)
    .service('MeurhVisualizarArquivoModalService', MeurhVisualizarArquivoModalService)
    .service('MeurhArquivosTrabalhadorService', MeurhArquivosTrabalhadorService)
    .service('MeurhArquivosTrabalhadorUploadModalService', MeurhArquivosTrabalhadorUploadModalService)
    .service('MeurhArquivosEmpresaService', MeurhArquivosEmpresaService)
    .config(MeurhArquivosEmpresaRouting)
    .name;
